import { useCheckboxState } from '../abstract/checkbox';

export function useStaffRoomsFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: staffRooms, setChecked: onStaffRoomsChange } = useCheckboxState({
    defaultValue: query.staffRooms,
    filterKey: `staffRooms`,
    setFilters,
    updateQuery,
  });

  return { staffRooms, onStaffRoomsChange };
}
